import en from "./en.json"
import de from "./de.json"
import fr from "./fr.json"
import es from "./es.json"
import it from "./it.json"
import ja from "./ja.json"
import ko from "./ko.json"

export default {
    en,
    de,
    fr,
    es,
    it,
    ja,
    ko
}